import React from 'react';
import { Switch } from 'react-router-dom';

import Route from './Route';

import SignIn from '../pages/SignIn';
import Dashboard from '../pages/Dashboard';
import Lojas from '../pages/Lojas';
import Relatorios from '../pages/Relatorios';
import Relatorio from '../pages/Relatorio';
import Indicadores from '../pages/Indicadores';
import VendasComparativas from '../pages/VendasComparativas';
import VendasDeProdutos from '../pages/VendasDeProdutos';
import Cadastros from '../pages/Cadastros/Principal';
import Classes from '../pages/Cadastros/Classes';
import Produtos from '../pages/Cadastros/Produtos';
import Marcas from '../pages/Cadastros/Marcas';
import Empresas from '../pages/Cadastros/Empresas';
import LocaisProducao from '../pages/Cadastros/LocaisProducao';

const Routes: React.FC = () => {
  return (
    <Switch>
      <Route path="/" exact component={SignIn} />

      <Route path="/dashboard" component={Dashboard} isPrivate />

      <Route path="/minhas-lojas" component={Lojas} isPrivate />

      <Route path="/relatorios" component={Relatorios} isPrivate />

      <Route path="/relatorio" component={Relatorio} isPrivate />

      <Route path="/indicadores" component={Indicadores} isPrivate />

      <Route
        path="/vendas-comparativas"
        component={VendasComparativas}
        isPrivate
      />

      <Route
        path="/vendas-de-produtos"
        component={VendasDeProdutos}
        isPrivate
      />

      <Route path="/cadastros" exact component={Cadastros} isPrivate />

      <Route path="/cadastros/classes" exact component={Classes} isPrivate />

      <Route path="/cadastros/produtos" exact component={Produtos} isPrivate />

      <Route path="/cadastros/marcas" exact component={Marcas} isPrivate />

      <Route path="/cadastros/empresas" exact component={Empresas} isPrivate />

      <Route
        path="/cadastros/locais_producao"
        exact
        component={LocaisProducao}
        isPrivate
      />
    </Switch>
  );
};

export default Routes;
